// extracted by mini-css-extract-plugin
module.exports = {"container":"back_container__k7eQS","optionContainer":"back_optionContainer__31mVB","icon":"back_icon__LHJzL"};